import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './LegalPage.css';

function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <Link to="/register" className="back-link">← {t('common.back')}</Link>
      
      <div className="legal-header">
        <img src="/images/ai-logo.png" alt="SmartGain Community" className="legal-logo" />
        <h1>{t('legal.privacy.title')}</h1>
        <p className="legal-meta">{t('legal.privacy.last_updated')}: 01/04/2026</p>
      </div>

      <div className="legal-content">
        <div className="legal-section">
          <p>{t('legal.privacy.intro')}</p>
        </div>

        <div className="legal-section">
          <h2>1. {t('legal.privacy.data_controller_title')}</h2>
          <p>{t('legal.privacy.data_controller_text')}</p>
        </div>

        <div className="legal-section">
          <h2>2. {t('legal.privacy.data_collected_title')}</h2>
          <p>{t('legal.privacy.data_collected_text')}</p>
          <h3>{t('legal.privacy.personal_data_title')}</h3>
          <ul>
            <li>{t('legal.privacy.personal_data_1')}</li>
            <li>{t('legal.privacy.personal_data_2')}</li>
            <li>{t('legal.privacy.personal_data_3')}</li>
            <li>{t('legal.privacy.personal_data_4')}</li>
          </ul>
          <h3>{t('legal.privacy.usage_data_title')}</h3>
          <ul>
            <li>{t('legal.privacy.usage_data_1')}</li>
            <li>{t('legal.privacy.usage_data_2')}</li>
            <li>{t('legal.privacy.usage_data_3')}</li>
          </ul>
          <h3>{t('legal.privacy.social_data_title')}</h3>
          <ul>
            <li>{t('legal.privacy.social_data_1')}</li>
            <li>{t('legal.privacy.social_data_2')}</li>
            <li>{t('legal.privacy.social_data_3')}</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>3. {t('legal.privacy.purpose_title')}</h2>
          <p>{t('legal.privacy.purpose_text')}</p>
          <ul>
            <li>{t('legal.privacy.purpose_1')}</li>
            <li>{t('legal.privacy.purpose_2')}</li>
            <li>{t('legal.privacy.purpose_3')}</li>
            <li>{t('legal.privacy.purpose_4')}</li>
            <li>{t('legal.privacy.purpose_5')}</li>
            <li>{t('legal.privacy.purpose_6')}</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>4. {t('legal.privacy.legal_basis_title')}</h2>
          <p>{t('legal.privacy.legal_basis_text')}</p>
          <ul>
            <li>{t('legal.privacy.legal_basis_1')}</li>
            <li>{t('legal.privacy.legal_basis_2')}</li>
            <li>{t('legal.privacy.legal_basis_3')}</li>
            <li>{t('legal.privacy.legal_basis_4')}</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>5. {t('legal.privacy.ai_processing_title')}</h2>
          <p>{t('legal.privacy.ai_processing_text')}</p>
        </div>

        <div className="legal-section">
          <h2>6. {t('legal.privacy.data_sharing_title')}</h2>
          <p>{t('legal.privacy.data_sharing_text')}</p>
          <ul>
            <li>{t('legal.privacy.data_sharing_1')}</li>
            <li>{t('legal.privacy.data_sharing_2')}</li>
            <li>{t('legal.privacy.data_sharing_3')}</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>7. {t('legal.privacy.international_transfers_title')}</h2>
          <p>{t('legal.privacy.international_transfers_text')}</p>
        </div>

        <div className="legal-section">
          <h2>8. {t('legal.privacy.retention_title')}</h2>
          <p>{t('legal.privacy.retention_text')}</p>
        </div>

        <div className="legal-section">
          <h2>9. {t('legal.privacy.rights_title')}</h2>
          <p>{t('legal.privacy.rights_text')}</p>
          <ul>
            <li>{t('legal.privacy.right_1')}</li>
            <li>{t('legal.privacy.right_2')}</li>
            <li>{t('legal.privacy.right_3')}</li>
            <li>{t('legal.privacy.right_4')}</li>
            <li>{t('legal.privacy.right_5')}</li>
            <li>{t('legal.privacy.right_6')}</li>
            <li>{t('legal.privacy.right_7')}</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>10. {t('legal.privacy.children_title')}</h2>
          <p>{t('legal.privacy.children_text')}</p>
        </div>

        <div className="legal-section">
          <h2>11. {t('legal.privacy.cookies_title')}</h2>
          <p>{t('legal.privacy.cookies_text')}</p>
        </div>

        <div className="legal-section">
          <h2>12. {t('legal.privacy.security_title')}</h2>
          <p>{t('legal.privacy.security_text')}</p>
        </div>

        <div className="legal-section">
          <h2>13. {t('legal.privacy.changes_title')}</h2>
          <p>{t('legal.privacy.changes_text')}</p>
        </div>

        <div className="legal-section">
          <h2>14. {t('legal.privacy.contact_title')}</h2>
          <p>{t('legal.privacy.contact_text')}</p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
